export default "__VITE_ASSET__DPiNlc6Y__"